// analytics.js
import posthog from "posthog-js";
import { CONSENT_KEY, CONSENT_GRANTED } from "./constants/consent";

const hasConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === CONSENT_GRANTED;
  } catch {
    return false;
  }
};

/**
 * Initialize PostHog analytics.
 */
export const initAnalytics = () => {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    defaults: '2025-05-24',
    capture_exceptions: true, // Capture exceptions using Error Tracking
    debug: process.env.NODE_ENV === 'development',
  });
};

/**
 * Track a page view event in PostHog.
 * @param {string} page - The path or name of the page.
 */
export const trackPageView = (page) => {
  if (hasConsent() && posthog.__loaded) {
    posthog.capture('$pageview', { path: page });
  }
};